export const state = () => ({
  orders: [],
  FilterDate: {},
  guestDetails: {},
  OrderTableDetails: {},
  OrderTableDetailsVisible:false,
  addingNewRoomVisible:false,
  addingNewRoomReservationId:null,
});

export const mutations = {
  addOrders(state, data) {
    var orders = state.orders;
    orders.push(data);
    state.orders = orders;
  },

  AddFilterDates(state, data) {
    state.FilterDate = data;
  },
  AddNewRoomReservationId(state, data) {
    state.addingNewRoomReservationId = data;
  },

  AddGuestDetails(state, data) {
    state.guestDetails = data;
  },
  updateRoomVisible(state, data) {
    state.addingNewRoomVisible = data;
  },

  AddOrderTableDetails(state, data) {
    state.OrderTableDetails = data;
  },
  AddOrderTableDetailsVisible(state, data) {
    state.OrderTableDetailsVisible = data;
  },

  removeorder(state, index) {
    var orders = state.orders;
    orders.splice(index, 1);
    state.orders = orders;
  },
  updateOrder(state, data) {
    state.orders = data;
  },
};

export const actions = {};

export const getters = {
  bookedRoomsIdList: function(state) {
    return state.orders.map((item) => item.id);
  },

  OrdersCount: function(state) {
    return state.orders.length;
  },

  TotalAmount: function(state) {
    var sum = 0;
    state.orders.map((e) => {
      if (e.totalAmount) {
        sum += parseFloat(e.totalAmount);
      }
    });
    return sum;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

// this.$store.commit('orders/addOrders',roomData)
// this.$store.commit('orders/removeorder',index)

// computed:{
//      ...mapState(orders,['orders'])
// },
// methods:{
//   removeOrder(index){
//     this.$store.commit('orders/removeorder',index)

//   }
// }

// <div v-for="(item,index) in orders">
//      <button @click="removeOrder(index)">Remove</button>
//</div >
